/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import uniqueId from 'lodash/uniqueId';
import {
  Error,
  Input,
  Label,
  Wrapper,
  Control,
  Handle,
} from '@components/Form/Checkbox/style';

const Checkbox = ({ infoTip, children, onClick, extraPadding, ...props }) => {
  const [field, meta] = useField(props);

  const fieldId = uniqueId(`field_${field.name}`);
  const hasError = meta.touched && meta.error;

  const checked = Array.isArray(meta.value)
    ? meta.value.indexOf(props.value.toString()) !== -1
    : meta.value;

  return (
    <Wrapper withError={hasError} onClick={onClick} className="custom-checkbox">
      <Input
        id={fieldId}
        withError={hasError}
        type="checkbox"
        checked={checked}
        {...field}
        {...props}
        onChange={ev => {
          field.onChange(ev);
          if (props.onChange) {
            props.onChange(ev);
          }
        }}
      />
      <Label htmlFor={fieldId} extraPadding={extraPadding}>
        <Control
          isDisabled={props.disabled}
          className="custom-checkbox__control"
        >
          <Handle />
        </Control>
        {children}
      </Label>

      {meta.touched && meta.error ? <Error>{meta.error}</Error> : null}
    </Wrapper>
  );
};

Checkbox.defaultProps = {
  extraPadding: true,
};

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  extraPadding: PropTypes.bool,
};

export default Checkbox;
